export default function reload(): void {
  window.location.reload();
}
